import { RadioGroup, FormControlLabel, FormControlLabelProps } from "@mui/material";
import { CoreRadio } from "./Radio";
import styles from "./radio.module.css";
import { RadioOption } from "./RadioGroup";

interface CoreRangedRadioProps {
	/**OnChange function for when radio button is pressed. This is set on RadioGroup */
	onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
	/**Pass either `radioGroupAriaLabelledby` or `radioGroupAriaLabel`. never both */
	radioGroupAriaLabelledby?: string;
	/**Pass either `radioGroupAriaLabelledby` or `radioGroupAriaLabel`. never both */
	radioGroupAriaLabel?: string;
	/**Information about each radio button */
	radioOptions: RadioOption[];
	/**Value of the radio button that is selected */
	curValue: string;
	/**Where to place the labels */
	labelPlacement?: FormControlLabelProps["labelPlacement"];
	/**Label placed top left of ranged radio. Example labels include "Least restrictive, Min, Lowest" etc */
	startLabel?: string;
	/**Label placed top right of ranged radio. Example labels include "Most restrictive, Max, Highest" etc */
	endLabel?: string;
}

export const CoreRangedRadio = ({
	onChange,
	radioGroupAriaLabelledby,
	radioGroupAriaLabel,
	radioOptions,
	curValue,
	labelPlacement = "bottom",
	startLabel,
	endLabel,
}: CoreRangedRadioProps) => {
	const valueIndex = radioOptions.findIndex((radio) => radio.value === curValue);
	const numItems = radioOptions.length;

	const rangedRadioGroup = (
		<RadioGroup
			row
			className={styles.rangeRadioGroup}
			value={curValue}
			onChange={onChange}
			aria-label={radioGroupAriaLabel}
			aria-labelledby={radioGroupAriaLabelledby}
		>
			<div className={styles.rangeRadioBarBackground}>
				<div className={styles.rangeRadioBarForeground} style={{ width: `${(valueIndex * 100) / (numItems - 1)}%` }} />
			</div>
			{radioOptions.map((radioOption) => {
				const { value, label, disabled } = radioOption;
				return (
					<FormControlLabel
						disableTypography
						labelPlacement={labelPlacement}
						className={styles.rangeRadioOption}
						key={value}
						value={value}
						disabled={disabled}
						control={<CoreRadio forceTabIndex={false} />}
						label={label}
					/>
				);
			})}
		</RadioGroup>
	);

	if (!endLabel || !startLabel) return rangedRadioGroup;

	return (
		<div className={styles.rangeRadioHeaderWrapper}>
			<div className={styles.rangeRadioHeader}>
				<span>{startLabel}</span>
				<span>{endLabel}</span>
			</div>
			{rangedRadioGroup}
		</div>
	);
};
